export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-background-100 rounded-2xl p-8 md:p-12 border border-background-300/20">
          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden border-2 border-background-300/30 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20streaming%20video%20app%20interface%20with%20movie%20thumbnails%20in%20a%20dark%20theme%2C%20warm%20amber%20accent%20highlights%2C%20clean%20UI%20with%20content%20grid%20layout%2C%20cinematic%20entertainment%20app%20design%2C%20premium%20dark%20background%20with%20subtle%20gradients&width=600&height=1067&seq=app-mockup-2026&orientation=portrait"
                alt="天美麻花星空影视APP界面"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50 mb-3">
              多端同步 · 随时随地免费看
            </h2>
            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-6 max-w-lg">
              天美麻花星空影视支持手机、平板、电脑与<strong className="text-foreground-200">大屏TV版</strong>全端同步观看。下载官方APP即可享受专属推荐、离线缓存和播放记录同步等便捷功能，超清蓝光画质在电视大屏上体验更震撼。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#contact"
                className="px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-950 font-bold text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                下载安卓版
              </a>
              <a
                href="#contact"
                className="px-6 py-2.5 bg-background-200 hover:bg-background-300 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/50 transition-all whitespace-nowrap cursor-pointer"
              >
                下载iOS版
              </a>
              <a
                href="#contact"
                className="px-6 py-2.5 bg-background-200 hover:bg-background-300 text-foreground-200 font-medium text-sm rounded-lg border border-background-300/50 transition-all whitespace-nowrap cursor-pointer"
              >
                TV版下载
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}